module.exports = __webpack_public_path__ + "static/media/lambda.8c5c6940.svg";